import AbstractAPI from '@/services/api/AbstractAPI';

export default class AddressApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/address');
  }

  listByPostcode(postcode, countryCode) {
    return this.makeRequest('/', 'get', {params: {postcode, countryCode}});
  }

  findById(id) {
    return this.makeRequest(`/${id}`, 'get');
  }
}
